export default {
  noDataText: 'No data found',
  loading: 'Loading data...',
  isCollectingDocuments: 'Collecting documents',
  others: 'Others',
  itemPerPage: 'Items per page',
  title: {
    medicineName: 'Medicine Name',
    create: 'Create New Prescription',
    edit: 'Edit Prescription',
    list: 'Ingredient List',
    pill: 'Tablet',
    category: 'Prescription Category'
  },
  placeholder: {
    no: 'Enter prescription code',
    quantityToOrder: 'Enter quantity to order',
    noOrDrugNameOrDoctor: 'Search by code, prescription name, or doctor\'s name',
    productName: 'Enter product name',
    manageProduct: 'Manage products',
    productNameEn: 'Enter product name (EN)',
    productNameCn: 'Enter product name (CN)',
    doctor: 'Select doctor (owner of the prescription)',
    category: 'Select category',
    howToUse: 'Enter usage instructions',
    time: 'Enter usage time',
    preserve: 'Enter storage instructions',
    properties: 'Enter properties',
    advice: 'Enter advice',
    ingredient: 'Select ingredient',
    plzIngredient: 'Please select an ingredient!',
    plzSelectData: 'Please select data',
    searchIdName: 'Search by prescription code or name',
    editCategory: 'Edit prescription category',
    enterCategory: 'Enter prescription category data',
    searchCategory: 'Search prescription category name',
    conditionFormula: 'Enter prescription condition',
    searchCondition: 'Search prescription condition name',
    plzEnterProfit: 'Please enter profit',
    enterProfit: 'Enter profit'
  },
  header: {
    no: 'Prescription Code',
    drugName: 'Prescription Name',
    productName: 'Product Name',
    doctor: 'Doctor\'s Name',
    category: 'Category',
    preserve: 'Storage Method',
    properties: 'Properties',
    howToUse: 'Usage Instructions',
    selectedUsage: 'Selected Usage',
    selectedUsageTime: 'Selected Usage Time',
    selectedStorageMethod: 'Selected Storage Method',
    time: 'Usage Time',
    unitConversion: 'Unit Conversion',
    advice: 'Advice',
    note: 'Note',
    status: 'Status',
    price: 'Sale Price',
    totalPrice: 'Total Price'
  },
  label: {
    category: 'Category',
    name: 'Prescription Category Name',
    nameTh: 'Product Name',
    nameEn: 'Product Name (EN)',
    nameCn: 'Product Name (CN)',
    doctor: 'Doctor (Owner of Prescription)',
    properties: 'Properties',
    howToUse: 'Usage Instructions',
    time: 'Usage Time',
    advice: 'Advice',
    note: 'Note',
    status: 'Status',
    preserve: 'Storage Instructions',
    unit: 'Unit',
    quantity: 'Quantity',
    quantityUnit: 'Quantity / Unit',
    condition: 'Condition',
    price: 'Sale Price',
    priceFormula: 'Prescription Price',
    bath: 'Baht',
    conditionFormula: 'Prescription Condition',
    editConditionFormula: 'Edit Prescription Condition',
    setAllProfit: 'Set Profit for All Prescriptions'
  },
  tooltip: {
    info: 'View Details',
    detail: 'View Ingredient Info',
    edit: 'Edit Info',
    delete: 'Delete Info',
    confirmDelete: 'Confirm Prescription Deletion',
    confirmDeleteDetail: 'You are deleting a prescription. Do you want to continue?',
    healthCertWithHistory: 'I request a health certificate with the following history',
    examiningDoctorStatement: 'I, the examining doctor, have physically examined the individual named above',
    profitInfo1: 'The entered profit will be added to the total ingredient cost to calculate the prescription price',
    hasConductedPhysicalExam: 'Has conducted a physical examination',
    profitInfo2: 'and will be used to calculate the commission for the dispenser',
    medicationWarning: 'If you experience issues with the medication, consult a doctor or pharmacist only',
    downloadMenuNotice: 'Your document is being prepared. Go to "Settings" and then "Download List" to view it.'
  },
  modal: {
    confirmDelete: 'Confirm Prescription Deletion',
    confirmDeleteDetail: 'You are deleting a prescription. Do you want to continue?',
    deleted: 'Prescription deleted successfully!',
    edited: 'Prescription updated successfully!',
    create: {
      price: 'Prescription price created successfully!',
      success: 'Prescription category added successfully!',
      condition: 'Prescription condition added successfully!'
    },
    edit: {
      price: 'Prescription price updated successfully!',
      condition: 'Prescription condition updated successfully!'
    },
    delete: {
      confirm: 'Confirm Prescription Category Deletion',
      confirmCondition: 'Confirm Prescription Condition Deletion',
      subtitle: 'You are deleting a prescription category. Do you want to continue?',
      subtitleCondition: 'You are deleting a prescription condition. Do you want to continue?',
      success: 'Prescription category deleted successfully!',
      condition: 'Prescription condition deleted successfully!'
    }
  },
  status: {
    dispensed: 'Dispensed',
    waiting: 'Waiting to Dispense',
    returned: 'Returned'
  }
}
